import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['item', 'buttons']

  connect() {
    this.updatePerPage()
    if (this.itemTargets.length > 0) {
      this.updatePaginationButtons()
      this.showPage(1)
      this.addFadeInToImages()
    }
    
    this.resizeHandler = this.handleResize.bind(this)
    window.addEventListener('resize', this.resizeHandler)
  }

  disconnect() {
    window.removeEventListener('resize', this.resizeHandler)
  }

  updatePerPage() {
    this.perPage = window.innerWidth < 768 ? 6 : 15
  }

  handleResize() {
    const oldPerPage = this.perPage
    this.updatePerPage()
    
    if (oldPerPage !== this.perPage) {
      this.updatePaginationButtons()
      this.showPage(1)
    }
  }

  updatePaginationButtons() {
    if (!this.hasButtonsTarget) return
    
    const totalPages = Math.ceil(this.itemTargets.length / this.perPage)
    const buttonsContainer = this.buttonsTarget
    
    // Hide buttons if there's only one page
    if (totalPages <= 1) {
      buttonsContainer.classList.add('hidden')
      return
    } else {
      buttonsContainer.classList.remove('hidden')
    }
    
    buttonsContainer.innerHTML = ''
    
    for (let i = 1; i <= totalPages; i++) {
      const button = document.createElement('button')
      button.className = 'w-10 h-10 rounded-2xl font-semibold text-base transition-all bg-white text-ih-indigo border border-ih-purple-20 hover:bg-ih-blue hover:text-white'
      button.dataset.page = i
      button.dataset.pageButton = ''
      button.textContent = i
      button.addEventListener('click', this.goToPage.bind(this))
      buttonsContainer.appendChild(button)
    }
  }

  addFadeInToImages() {
    const images = this.element.querySelectorAll('img')
    images.forEach((img, index) => {
      if (img.complete) {
        setTimeout(() => {
          img.classList.add('fade-in-on-load', 'visible')
        }, index * 50)
      } else {
        img.addEventListener('load', () => {
          setTimeout(() => {
            img.classList.add('fade-in-on-load', 'visible')
          }, index * 50)
        })
      }
    })
  }

  showPage(page) {
    const start = (page - 1) * this.perPage
    const end = start + this.perPage
    
    this.itemTargets.forEach((item, index) => {
      const img = item.querySelector('img')
      if (img) {
        img.classList.remove('visible')
      }
      
      if (index >= start && index < end) {
        item.classList.remove('hidden')
        setTimeout(() => {
          if (img) {
            img.classList.add('visible')
          }
        }, (index - start) * 50)
      } else {
        item.classList.add('hidden')
      }
    })
    
    this.updateActivePageButton(page)
  }

  goToPage(event) {
    const page = parseInt(event.currentTarget.dataset.page)
    this.showPage(page)
  }

  updateActivePageButton(currentPage) {
    document.querySelectorAll('[data-page-button]').forEach(button => {
      const buttonPage = parseInt(button.dataset.page)
      if (buttonPage === currentPage) {
        button.classList.add('bg-ih-blue', 'text-white')
        button.classList.remove('bg-white', 'text-ih-indigo')
      } else {
        button.classList.remove('bg-ih-blue', 'text-white')
        button.classList.add('bg-white', 'text-ih-indigo')
      }
    })
  }
}
